export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_RESET_CONFIRMATION_MESSAGE =
  "If an account exists with that email, you'll receive a reset link shortly. Check your spam folder if it doesn't arrive.";

export const BILLING_UNAVAILABLE_MESSAGE =
  "Billing is temporarily unavailable. Your access isn't affected — try again shortly, or contact support@sitescopeapp.com if this persists.";

export const SUBSCRIPTION_LOOKUP_FAILED_MESSAGE =
  "We couldn't load your subscription details. This won't affect your current access. Try refreshing, or contact support@sitescopeapp.com.";
